import { render, staticRenderFns } from "./recovery-password.vue?vue&type=template&id=766ad284&"
import script from "./recovery-password.vue?vue&type=script&lang=js&"
export * from "./recovery-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/home/ubuntu/bejuco/web/components/logo.vue').default})
